import PremiumFeatureModal from "../modal/premiumFeatureModal/PremiumFeatureModal";
import { SubscriptionPlansContext } from "../../context/SubscriptionPlansContext";
import AgentLanguageSelector from "./languageSelector/AgentLanguageSelector";
import { CategoriesContext } from "../../context/CategoriesContext";
import { LanguageContext } from "../../context/LanguageContext";
import ChatMessages from "./chatMessages/ChatMessages";
import Suggestions from "./suggestions/Suggestions";
import AgentInput from "./agentInput/AgentInput";
import classes from "./AgentButton.module.css";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import Loader from "../spinner/Loader";
import { getRequiredPlan, hasFeatureAccess } from "../../utils/helpers/subscriptions/utils";
import { useCurrentUser } from "../../hooks/useCurrentUser";

const AgentButton = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState("");
  const [lang, setLang] = useState("en");
  const [message, setMessage] = useState("");
  const [langOpen, setLangOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [cachedSuggestions, setCachedSuggestions] = useState({});
  const [requiredPlan, setRequiredPlan] = useState({});
  const { user } = useCurrentUser();
  const { categories: allCategories } = useContext(CategoriesContext);
  const { subscriptionPlans } = useContext(SubscriptionPlansContext);

  const agentSuggestionListData = useSelector((state) => state.agentSuggestionList);
  const suggestionsList = agentSuggestionListData?.agentSuggestions;

  function handleAgentClick() {
    if (hasFeatureAccess(subscriptionPlans, user?.plan, "aiAssistant")) {
      setOpen((v) => (v === "agent" ? "" : "agent"));
    } else {
      const plan = getRequiredPlan(subscriptionPlans, "aiAssistant")
      setRequiredPlan(plan)
      setOpen("popup");
    }
    setMessage("")
  }

  return (
    <LanguageContext.Consumer>
      {({ data, language: ctxLang }) => {
        const t = (key) => data?.[key]?.[ctxLang];

        return (
          <>
            <div className={`${classes.dropdown} ${open === "agent" ? classes.dropdownOpen : ""}`}>
              <div className={classes.header}>
                <span className={classes.headerTitle}>{t("vinni_assistant")}</span>
                <button className={classes.closeBtn} onClick={() => { setOpen(""); setMessage("") }}>✕</button>
              </div>

              <AgentLanguageSelector {...{lang, langOpen, setLang, setLangOpen, cachedSuggestions, setCachedSuggestions, suggestionsList, setIsLoading, t}}/>
              {chatMessages.length === 0 && !isLoading ? (
                <Suggestions suggestions={cachedSuggestions[lang]} isLoading={isLoading} onSelect={(text) => { setMessage(text); setLangOpen(false) }}/>
              ) : isLoading ? (
                <Loader className={classes.customLoaderHeight} />
              ) : (
                <ChatMessages {...{chatMessages, setChatMessages, setOpen, allCategories, t, ctxLang}}/>
              )}
              <AgentInput {...{ message, setMessage, setOpen, setChatMessages, allCategories, lang, t }}/>
            </div>

            {open === "popup" && (
              <PremiumFeatureModal setOpen={setOpen} t={t} onUpgrade={() => navigate("/subscription-plans") } requiredPlan={requiredPlan}/>
            )}

            {open === "agent" && <div className={classes.backdrop} onClick={() => { setOpen(""); setMessage("") }} />}
            <button className={classes.aiAgentBtn} onClick={handleAgentClick}>
              <img src="/assets/aiAgent/aiAgent.svg" alt="" />
            </button>
          </>
        );
      }}
    </LanguageContext.Consumer>
  )
};

export default AgentButton;